import initDrawer from "./initDrawer";
import initGoTopBtn from "./initGoTopBtn";
import initHeader from "./initHeader";
import initSmoothScroll from "./initSmoothScroll";
import initSlider from "./initSlider";
import initViewport from "./initViewport";
import initAgreeCheckbox from "./initAgreeCheckbox";

export default function initCommonScript() {
  // viewport固定
  initViewport();

  // headerコンテンツ
  initHeader();

  // スムーススクロール
  initSmoothScroll();

  // ドロワーメニュー
  initDrawer();

  // TOPに戻るボタン
  initGoTopBtn();

  //スライドショー
  initSlider();

  //同意チェックボックス
  initAgreeCheckbox();
}
